import React from 'react';
import './style.scss'


function Loading(props) {
    return (
        <div className="center-on-page">
            <div className="pokeball">
                <div className="pokeball__button"></div>
            </div>
        </div>
    );
}

export default Loading;